module.exports = __webpack_public_path__ + "media/top/separation-27151d08.png";